export default __webpack_public_path__ + "static/media/Icon material-account-circle.8c91080c.svg";